"use client";
import { useState, useEffect, useMemo } from "react";
import { IoMdClose } from "react-icons/io";
import { IoCheckmark } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import Modal from "./Modal";
import Spinner from "./Spinner";
import { format } from "date-fns";
import { toast } from "react-toastify";
// import { getAdjustedEventDate } from "../utils/sendToPrint";

const GenerateCardPopup = ({
  toggleOrderModal,
  selectedCard,
  selectedCardID,
  data,
  cards,
  eventData = {},
  type,
}) => {
  const [loader, setLoader] = useState(true);
  const [messageTheme, setMessageTheme] = useState([]);
  const [eventId, setEventId] = useState("");
  const [recipients, setRecipients] = useState([]);
  const [selectedRecipient, setSelectedRecipient] = useState("");
  const [recipientDetails, setRecipientDetails] = useState({
    recipientID: "",
    name: "",
    relationship: "",
    occasion: "",
    birthday: "",
    gender: "",
    character_traits: [],
  });
  // const [orderStatus, setOrderStatus] = useState(null); // To store the order validation result
  // const [isDateAdjusted, setIsDateAdjusted] = useState(false); // To store adjusted date check result
  const [me, setMe] = useState("");
  const token = localStorage.getItem("token");
  const customerID = localStorage.getItem("ID");

  const fetchMe = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/me`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
      });
      const data = await res.json();
      if (res.status === 200) setMe(data.detail.fullName);
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const fetchRecipients = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/get-customer-recipients/${customerID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();
      setRecipients(data.data || []); // Ensure recipients is always an array
    } catch (error) {
      console.error("Failed to fetch recipients:", error);
    } finally {
      setLoader(false);
    }
  };
  const navigate = useNavigate();
  const handleSave = () => {
    if (type === "demo" && !token) {
      navigate("/signup");
      return;
    }

    if (!validateForm()) return;

    const {
      name,
      recipientID,
      relationship,
      occasion,
      birthday,
      gender,
      character_traits,
    } = recipientDetails;

    window.location.href = `/dashboard/card_generation/pick?name=${name}&recipientID=${recipientID}&relationship=${relationship}&occasion=${occasion}&eventId=${eventId}&birthday=${birthday}&gender=${gender}&character_traits=${character_traits}&messageTheme=${messageTheme}&me=${me}&thumbnail=${selectedCard}&selectedCardID=${selectedCardID}&eventDate=${recipientDetails?.eventDate}`;
  };

  const validateForm = () => {
    if (recipients.length === 0) {
      toast.error("Please click on 'Add' button to add a recipient first.");
      return false;
    }
    if (messageTheme.length < 1 && selectedRecipient === "" && eventId == "") {
      toast.error("Please fill all the details.");
      return false;
    }
    if (selectedRecipient === "" && eventId == "") {
      toast.error("Please select recipient and occasion.");
      return false;
    }
    if (selectedRecipient === "") {
      toast.error("Please select a recipient");
      return false;
    }
    if (!eventId && messageTheme.length < 1) {
      toast.error("Please select an occasion and message theme");
      return false;
    }
    if (!eventId) {
      toast.error("Please select an event");
      return false;
    }
    if (messageTheme.length < 1) {
      toast.error("Please select at least 1 message themes");
      return false;
    }
    // // Check order status after validation
    // if (orderStatus === "no-order") {
    //   return true; // Proceed because there is no order
    // } else if (orderStatus === "valid-expired-order") {
    //   return true; // Proceed because the order is expired (from a previous month/year)
    // } else if (orderStatus === "future-or-today") {
    //   toast.error(
    //     "An order already exists for this recipient."
    //   );
    //   return false; // Restrict proceeding because the first order's date is in the future or today
    // }

    return true;
  };

  useEffect(() => {
    if (type === "demo" && !token) {
      setLoader(false);
      return;
    }
    if (token) fetchMe();
    if (customerID && token) fetchRecipients();
  }, [token, customerID]);
  const normalizeEventName = (eventName) => {
    return (
      eventName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "") // Remove non-alphanumeric characters (e.g., apostrophes, spaces)
        .replace(/\s+/g, "") // Remove spaces
        .replace(/^([a-z])/g, (match) => match.toLowerCase()) + "Date"
    ); // Ensure camelCase and add 'Date'
  };

  // useEffect(() => {
  //   const recipient = recipients.find((r) => r._id === selectedRecipient);
  //   const annualEvent = recipients
  //   .find((r) => r._id === selectedRecipient)
  //   ?.eventsId.filter((item) => item._id === eventId && item.recurrence === "annual")
  //   const filteredOccasion = recipients
  //     .find((r) => r._id === selectedRecipient)
  //     ?.eventsId.filter((item) => item._id === eventId)[0]?.name;
  //   const normalname = filteredOccasion && normalizeEventName(filteredOccasion);
  //   console.log({normalname, recipient, filteredOccasion, annualEvent})
  //   if (recipient) {
  //     setRecipientDetails({
  //       recipientID: recipient._id,
  //       name: recipient.fullName,
  //       relationship: recipient.relationShip,
  //       character_traits: recipient.characterTraits,
  //       gender: recipient.gender,
  //       birthday: format(new Date(recipient.dob), "yyyy-MM-dd"),
  //       eventDate:
  //         filteredOccasion === "Birthday"
  //           ? format(new Date(recipient.dob), "yyyy-MM-dd")
  //           : recipient[normalname] ? recipient[normalname] : annualEvent[0]?.date,
  //     });

  //     const event = recipient.eventsId.find((e) => e._id === eventId);
  //     if (event)
  //       setRecipientDetails((prev) => ({ ...prev, occasion: event.name }));
  //   }
  // }, [selectedRecipient, eventId, recipients]);

  useEffect(() => {
    // Find the recipient once to avoid redundant lookups
    const recipient = recipients.find((r) => r._id === selectedRecipient);

    if (!recipient) return;

    // Find the specific event by ID
    const event = recipient.eventsId?.find((e) => e._id === eventId);

    // Filter for annual events matching the event ID
    const annualEvent = recipient.eventsId?.filter(
      (item) => item._id === eventId && item.recurrence === "annual"
    );

    // Normalize event name if applicable
    const eventName = event?.name;
    const normalizedEventName = eventName && normalizeEventName(eventName);

    // Calculate the event date with fallbacks
    const eventDate = (() => {
      if (eventName === "Birthday") {
        return format(new Date(recipient.dob), "yyyy-MM-dd");
      }
      if (recipient[normalizedEventName]) {
        return recipient[normalizedEventName];
      }
      if (annualEvent?.[0]?.date) {
        return annualEvent[0].date;
      }
      return "No date available";
    })();

    setRecipientDetails({
      recipientID: recipient._id,
      name: recipient.fullName || "Unknown",
      relationship: recipient.relationShip || "Unknown",
      character_traits: recipient.characterTraits || "None",
      gender: recipient.gender || "Unspecified",
      birthday: format(new Date(recipient.dob), "yyyy-MM-dd"),
      eventDate,
      occasion: eventName || "Unknown",
    });
  }, [selectedRecipient, eventId, recipients]);

  const handleMessageThemeSelection = (theme) => {
    setMessageTheme((prevThemes) =>
      prevThemes.includes(theme)
        ? prevThemes.filter((t) => t !== theme)
        : [...prevThemes, theme]
    );
  };

  const isThemeSelected = (theme) => messageTheme.includes(theme);

  const recipientOptions = useMemo(
    () =>
      recipients.map((recipient) => (
        <option key={recipient._id} value={recipient._id}>
          {recipient.fullName}
        </option>
      )),
    [recipients]
  );
  useEffect(() => {
    const selectedRecipient1 = recipients.find(
      (res) => res._id === selectedCardID
    );
    if (selectedRecipient1) {
      setSelectedRecipient(selectedRecipient1._id);
    }
  }, [selectedCardID, recipients]);
  useEffect(() => {
    const test = recipients.find((res) => res?.fullName === data?.fullName);

    if (test) {
      // Check if test is not null or undefined
      setSelectedRecipient(test._id);
    }
  }, [data, recipients]);

  useEffect(() => {
    const test = recipients.find(
      (res) => res?.fullName === eventData?.receiptsId?.fullName
    );
    if (eventData && test) {
      // Check if test is not null or undefined
      setSelectedRecipient(test._id);
      setEventId(eventData.eventId);
    }
  }, [eventData, recipients]);
  // console.log({eventData, recipientDetails})

  if (loader) {
    return (
      <Modal toggleOrderModal={toggleOrderModal}>
        <div className="flex flex-col items-center justify-center">
          <div className="bg-secondary w-full h-fit px-4 py-4 mb-4 rounded-t-lg flex items-center justify-between">
            <h1 className="text-2xl text-white">Add Order</h1>
            <IoMdClose
              size={30}
              color="white"
              className="cursor-pointer"
              onClick={toggleOrderModal}
            />
          </div>
          <div className="w-full p-5">
            <Spinner props={"Loading"} size={"100px"} />
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <Modal toggleOrderModal={toggleOrderModal}>
      <div className="flex flex-col items-center justify-center">
        <div className="bg-secondary w-full h-fit px-4 py-4 mb-4 rounded-t-lg flex items-center justify-between">
          <h1 className="text-2xl text-white">
            {type === "demo" && !token ? "Add Card" : "Add Order"}
          </h1>
          <IoMdClose
            size={30}
            color="white"
            className="cursor-pointer"
            onClick={toggleOrderModal}
          />
        </div>
        <div className="w-full p-5">
          <div className="m-2 w-full">
            <label className="block text-sm font-medium text-gray-500">
              Select Recipients
            </label>
            <div className="flex items-center gap-2">
              <select
                className="bg-gray-100 border border-gray-300 py-2 px-3 w-full text-black rounded-md"
                name="selectedRecipient"
                disabled={!!eventData?.eventId || recipients.length === 0}
                value={selectedRecipient}
                onChange={(e) => {
                  setSelectedRecipient(e.target.value);
                  // console.log(
                  //   e.target.value,
                  //   recipients.find((event) => event?._id == e.target.value)
                  // );
                }}
                required
              >
                <option value="" disabled>
                  --Select--
                </option>
                {recipients.length > 0 ? (
                  recipientOptions
                ) : (
                  <option value="">No recipients available</option>
                )}
              </select>
              <Link
                to={
                  type === "demo" && !token
                    ? "/signup"
                    : "/dashboard/address_book/add"
                }
              >
                {selectedRecipient == "" && (
                  <button className="bg-primary text-white hover:bg-primary-dark py-2 px-4 rounded-md">
                    Add
                  </button>
                )}
              </Link>
            </div>
          </div>

          <div
            className={`m-2 my-4 ${
              selectedRecipient == "" ? "mr-[62px]" : "mr-0"
            }`}
          >
            <label className="block text-sm font-medium text-gray-500">
              Select Occasion
            </label>
            <select
              className="bg-gray-100 border border-gray-300 py-2 px-3 w-full text-black rounded-md"
              name="selectedOccasion"
              disabled={!!eventData?.eventId || !selectedRecipient}
              value={eventId}
              onChange={(e) => setEventId(e.target.value)}
              required
            >
              <option value="" disabled>
                --Select--
              </option>
              {selectedRecipient &&
                recipients
                  .find((r) => r._id === selectedRecipient)
                  ?.eventsId.map((event) => {
                    return (
                      <option key={event._id} value={event._id}>
                        {event.name}
                      </option>
                    );
                  })}
            </select>
          </div>

          <h3 className="text-lg text-gray-500 m-2 my-4">
            Message Themes (Multiple Select)
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 place-items-center m-2 mb-5 gap-3">
            {[
              "Warm or Heartfelt",
              "Christian or Spiritual",
              // "Festive or Joyful",
              "Playful or Witty",
            ].map((theme) => (
              <button
                key={theme}
                className={`w-full rounded-md py-3 px-2 flex items-center justify-center text-xl border-2 ${
                  isThemeSelected(theme)
                    ? "bg-primary border-primary text-white"
                    : "border-gray-300 hover:border-primary hover:text-primary"
                }`}
                onClick={() => handleMessageThemeSelection(theme)}
              >
                {theme}
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-4 w-full justify-center mb-4">
          <button
            className="border-2 border-gray-300 text-gray-500 hover:bg-gray-200 py-2 px-8 rounded-md flex items-center justify-center gap-x-2"
            onClick={toggleOrderModal}
          >
            <IoMdClose size={30} />
            <span className="font-medium">Cancel</span>
          </button>
          <button
            onClick={handleSave}
            className="bg-primary hover:bg-primary-dark border-2 border-primary text-white py-2 px-8 rounded-md flex items-center justify-center gap-x-2"
          >
            <IoCheckmark size={30} />
            <span className="font-medium">Proceed</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default GenerateCardPopup;

// "use client";
// import { useState, useEffect } from "react";
// import { IoMdClose } from "react-icons/io";
// import { IoCheckmark } from "react-icons/io5";
// import { Link } from "react-router-dom";
// import Modal from "./Modal";
// import Spinner from "./Spinner";
// import { format } from "date-fns";
// import { toast } from "react-toastify";

// const GenerateCardPopup = ({
//   toggleOrderModal,
//   selectedCard,
//   selectedCardID,
// }) => {
//   const [loader, setLoader] = useState(true);
//   const [messageTheme, setMessageTheme] = useState([]);
//   const [eventId, setEventId] = useState("");
//   const [recipients, setRecipients] = useState([]);
//   const [selectedRecipient, setSelectedRecipient] = useState("");
//   const [recipientID, setRecipientID] = useState("");
//   const [name, setName] = useState("");
//   const [relationship, setRelationship] = useState("");
//   const [occasion, setOccasion] = useState("");
//   const [birthday, setBirthday] = useState("");
//   const [gender, setGender] = useState("");
//   const [character_traits, setCharacter_traits] = useState([]);
//   const [me, setMe] = useState("");

//   const handleSave = async () => {
//     if (recipients.length === 0) {
//       toast.error("Please click on 'Add' button to add a recipient first.");
//       return;
//     }

//     if (messageTheme.length < 2) {
//       toast.error("Please select at least 2 message themes");
//       return;
//     }
//     if (!selectedRecipient) {
//       toast.error("Please select a recipient");
//       return;
//     }
//     if (!eventId) {
//       toast.error("Please select an event");
//       return;
//     }
//     if (messageTheme.length === 0) {
//       toast.error("Please select a message theme");
//       return;
//     }

//     window.location.href =
//       "/dashboard/card_generation/pick?name=" +
//       name +
//       "&recipientID=" +
//       recipientID +
//       "&relationship=" +
//       relationship +
//       "&occasion=" +
//       occasion +
//       "&eventId=" +
//       eventId +
//       "&birthday=" +
//       birthday +
//       "&gender=" +
//       gender +
//       "&character_traits=" +
//       character_traits +
//       "&messageTheme=" +
//       messageTheme +
//       "&me=" +
//       me +
//       "&thumbnail=" +
//       selectedCard +
//       "&selectedCardID=" +
//       selectedCardID;
//   };

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const fetchMe = async () => {
//       try {
//         const res = await fetch("/api/auth/me", {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             "x-sh-auth": token,
//           },
//         });
//         const data = await res.json();
//         if (res.status === 200) {
//           setMe(data.detail.fullName);
//         }
//       } catch (error) {
//         console.error("Failed to fetch user data:", error);
//       }
//     };
//     if (token) {
//       fetchMe();
//     }
//   }, []);

//   useEffect(() => {
//     if (selectedRecipient) {
//       const recipient = recipients.find(
//         (recipient) => recipient._id === selectedRecipient
//       );
//       if (recipient) {
//         setRecipientID(recipient._id);
//         setName(recipient.fullName);
//         setRelationship(recipient.relationShip);
//         setCharacter_traits(recipient.characterTraits);
//         setGender(recipient.gender);
//         const birthday = format(new Date(recipient.dob), "yyyy-MM-dd");
//         setBirthday(birthday);

//         const event = recipient?.eventsId.find((item) => item._id === eventId);
//         if (event) {
//           setOccasion(event.name);
//         }
//       }
//     }
//   }, [selectedRecipient, eventId, recipients]);

//   useEffect(() => {
//     const fetchRecipients = async (customerID, token) => {
//       try {
//         const res = await fetch(
//           `/api/customer/get-customer-recipients/${customerID}`,
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//               "x-sh-auth": token,
//             },
//           }
//         );
//         const data = await res.json();
//         setRecipients(data.data || []); // Ensure recipients is always an array
//       } catch (error) {
//         console.error("Failed to fetch recipients:", error);
//       } finally {
//         setLoader(false);
//       }
//     };
//     const customerID = localStorage?.getItem("ID");
//     const token = localStorage?.getItem("token");
//     if (customerID && token) {
//       fetchRecipients(customerID, token);
//     } else {
//       setLoader(false);
//     }
//   }, []);

//   const handleMessageThemeSelection = (theme) => {
//     setMessageTheme((prevThemes) => {
//       if (prevThemes.includes(theme)) {
//         return prevThemes.filter((t) => t !== theme);
//       } else {
//         return [...prevThemes, theme];
//       }
//     });
//   };

//   const isThemeSelected = (theme) => messageTheme.includes(theme);

//   if (loader) {
//     return (
//       <Modal toggleOrderModal={toggleOrderModal}>
//         <div className="flex flex-col items-center justify-center">
//           <div className="bg-secondary w-full h-fit px-4 py-4 mb-4 rounded-t-lg flex items-center justify-between">
//             <h1 className="text-2xl text-white">Add Order</h1>
//             <IoMdClose
//               size={30}
//               color="white"
//               className="cursor-pointer"
//               onClick={toggleOrderModal}
//             />
//           </div>
//           <div className="w-full p-5">
//             <Spinner props={"Loading"} size={"100px"} />
//           </div>
//         </div>
//       </Modal>
//     );
//   } else {
//     return (
//       <Modal toggleOrderModal={toggleOrderModal}>
//         <div className="flex flex-col items-center justify-center">
//           <div className="bg-secondary w-full h-fit px-4 py-4 mb-4 rounded-t-lg flex items-center justify-between">
//             <h1 className="text-2xl text-white">Add Order</h1>
//             <IoMdClose
//               size={30}
//               color="white"
//               className="cursor-pointer"
//               onClick={toggleOrderModal}
//             />
//           </div>
//           <div className="w-full p-5">
//             <div className="flex items-center gap-3 w-full">
//               <div className="m-2 w-full">
//                 <label className="block text-sm font-medium text-gray-500">
//                   Select Recipients
//                 </label>
//                 <div className="flex items-center gap-2">
//                   <select
//                     className="bg-gray-100 border border-gray-300 py-2 px-3 w-full text-black rounded-md"
//                     name="selectedRecipient"
//                     disabled={recipients.length === 0}
//                     value={selectedRecipient}
//                     onChange={(e) => setSelectedRecipient(e.target.value)}
//                     required
//                   >
//                     <option value="" disabled>
//                       --Select--
//                     </option>
//                     {recipients.length > 0 ? (
//                       recipients.map((recipient) => (
//                         <option key={recipient._id} value={recipient._id}>
//                           {recipient.fullName}
//                         </option>
//                       ))
//                     ) : (
//                       <option value="">No recipients available</option>
//                     )}
//                   </select>
//                   <Link to={"/dashboard/address_book/add"}>
//                     <button className="bg-yellow-500 text-black hover:bg-yellow-600 py-2 px-4 rounded-md">
//                       Add
//                     </button>
//                   </Link>
//                 </div>
//               </div>
//             </div>
//             <div className="m-2 my-4">
//               <label className="block text-sm font-medium text-gray-500">
//                 Select Occasion
//               </label>
//               <select
//                 className="bg-gray-100 border border-gray-300 py-2 px-3 w-full text-black rounded-md"
//                 name="selectedOccasion"
//                 disabled={!selectedRecipient}
//                 value={eventId}
//                 onChange={(e) => setEventId(e.target.value)}
//                 required
//               >
//                 <option value="" disabled>
//                   --Select--
//                 </option>
//                 {selectedRecipient &&
//                   recipients
//                     .find((recipient) => recipient._id === selectedRecipient)
//                     ?.eventsId.map((event) => (
//                       <option key={event._id} value={event._id}>
//                         {event.name}
//                       </option>
//                     ))}
//               </select>
//             </div>
//             <h3 className="text-lg text-gray-500 m-2 my-4">
//               Message Themes (Multiple Select)
//             </h3>
//             <div className="grid md:grid-cols-2 lg:grid-cols-3 place-items-center m-2 mb-5 gap-3">
//               <button
//                 className={`w-full rounded-md py-3 px-2 flex items-center justify-center text-xl border-2 ${
//                   isThemeSelected("Warm or Heartfelt")
//                     ? "bg-yellow-500 border-yellow-500 text-black"
//                     : "border-gray-300 hover:border-yellow-500 hover:text-yellow-500"
//                 }`}
//                 onClick={() => handleMessageThemeSelection("Warm or Heartfelt")}
//               >
//                 Warm or Heartfelt
//               </button>
//               <button
//                 className={`w-full rounded-md py-3 px-2 flex items-center justify-center text-xl border-2 ${
//                   isThemeSelected("Christian or Spiritual")
//                     ? "bg-yellow-500 border-yellow-500 text-black"
//                     : "border-gray-300 hover:border-yellow-500 hover:text-yellow-500"
//                 }`}
//                 onClick={() =>
//                   handleMessageThemeSelection("Christian or Spiritual")
//                 }
//               >
//                 Christian or Spiritual
//               </button>
//               <button
//                 className={`w-full rounded-md py-3 px-2 flex items-center justify-center text-xl border-2 ${
//                   isThemeSelected("Festive or Joyful")
//                     ? "bg-yellow-500 border-yellow-500 text-black"
//                     : "border-gray-300 hover:border-yellow-500 hover:text-yellow-500"
//                 }`}
//                 onClick={() => handleMessageThemeSelection("Festive or Joyful")}
//               >
//                 Festive or Joyful
//               </button>
//               <button
//                 className={`w-full rounded-md py-3 px-2 flex items-center justify-center text-xl border-2 ${
//                   isThemeSelected("Playful or Witty")
//                     ? "bg-yellow-500 border-yellow-500 text-black"
//                     : "border-gray-300 hover:border-yellow-500 hover:text-yellow-500"
//                 }`}
//                 onClick={() => handleMessageThemeSelection("Playful or Witty")}
//               >
//                 Playful or Witty
//               </button>
//             </div>
//           </div>
//           <div className="flex items-center justify-center gap-x-5 w-full text-xl mb-5">
//             <button
//               className="border-2 border-gray-300 text-gray-500 hover:bg-gray-200 py-2 px-8 rounded-md flex items-center justify-center gap-x-2"
//               onClick={toggleOrderModal}
//             >
//               <IoMdClose size={30} />
//               <span className="font-medium">Cancel</span>
//             </button>
//             <button
//               onClick={handleSave}
//               className="bg-yellow-500 hover:bg-yellow-600 border-2 border-yellow-500 text-black py-2 px-8 rounded-md flex items-center justify-center gap-x-2"
//             >
//               <IoCheckmark size={30} />
//               <span className="font-medium">Proceed</span>
//             </button>
//           </div>
//         </div>
//       </Modal>
//     );
//   }
// };

// export default GenerateCardPopup;
